import request from './request'
import type { ApiResponse } from './types'
/**
 * 获取 HTTP code 字典
 */
export function appConfigsCodesApi(data: {
  ver: string
}): Promise<ApiResponse<{ codes: Array<{ code: string; cn: string }>; ver: string }>> {
  return request.get('/app/configs/codes', { params: data })
}

/** 获取分享配置信息 */
export function appConfigsShareApi(): Promise<ApiResponse<{ qr_code: string; landing_url: string;  }>> {
  return request.get('/app/configs/share')
}

/** 获取 USDT 买 KB 汇率 */
export function appConfigsUsdtBuyKbRateApi(): Promise<ApiResponse<{ rate: number, min: number }>> {
  return request.get('/deposit/usdt/preflight')
}

/** USDT 充值确认 */
export function appConfigsUsdtBuyKbConfirmApi(data: { rate: number, amount: number, currency: string }): 
Promise<ApiResponse<{ address: string }>> {
  return request.post('/deposit/usdt/confirm', data)
}

/** USDT充值提交 */
export function appConfigsUsdtBuyKbSubmitApi(data: { to_address: string, amount: number, proof_id: number, currency: string }): Promise<ApiResponse<null>> {
  return request.post('/deposit/usdt/commit', data)
}

export interface UsdtBuyLbHistoryItem {
  /** 交易单号 */
  order_no: string;
  /** 支付金额 */
  usdt:   number;
  /** 到账数量 */
  receive_coin: number;
  /** 货币单位 */
  currency: string;
  /** 状态，0=待审核，1=兑换成功，2=审核拒绝 */
  status: number;
  /** 备注 */
  remark: string;
  /** 记录时间，时间戳(秒) */
  created_at: number;
}

/** USDT充值历史列表 */
export function appConfigsUsdtBuyLbHistoryApi(data: { 
  page: number; 
  size: number; 
  start_at: number; 
  end_at: number; 
}): 
Promise<ApiResponse<Array<UsdtBuyLbHistoryItem>>> {
  return request.post('/deposit/usdt/history', data)
}